import _ from 'lodash'
//状态

class BlockState {
    //状态估值
    f = 0
    //从初始到当前状态的步数
    g = 0
    //当前状态到最终状态的步数
    h = 0

    blocks: number[] = []
    parentBlockState
    moveBlocks = []
    //拼图规格

    moveStep: any
    successBlocks = []
    robot

    constructor(blocks: number[], robot: Robot, parentBlockState?: BlockState) {
        this.blocks = blocks
        this.parentBlockState = parentBlockState
        this.robot = robot
    }

    setMoveBlocks(from: any, to: any) {
        this.moveStep = {
            from,
            to,
        }
    }

    //获取块的行列数据
    getPlaceBlock(index: number) {
        const row = Math.floor(index / this.robot.rows)
        const col = index < this.robot.cols ? index : index % this.robot.cols
        return { row, col }
    }

    //转成字符串
    getBlockData() {
        return this.blocks.toString()
    }

    //计算评估值
    getF() {
        this.f = this.f ? this.f : this.calcG() + this.calcH()
        return this.f
    }

    //计算从父状态到当前状态的步数
    calcG() {
        if (this.parentBlockState) {
            this.g = this.parentBlockState.g + 1
        }
        return this.g
    }

    //从当前状态到完成状态的步数
    calcH() {
        // this.blocks.forEach((e, i) => this.h += this.calcDistance(this.getPlaceBlock(i), this.getPlaceBlock(e == 0 ? this.robot.successBlocks.length - 1 : e - 1)));
        this.h = this.blocks.reduce(function (prev, cur, index, arr) {
            return prev - (cur != index ? 1 : 0)
        }, 8)
        return this.h
    }

    //计算距离,曼哈顿距离
    calcDistance(from: any, to: any) {
        return Math.abs(from.row - to.row) + Math.abs(from.col - to.col)
    }

    //扩展子状态
    expand() {
        const index0 = this.blocks.indexOf(this.robot.blankBlockIndex) //获取空白位索引
        const childBlocks: BlockState[] = []

        this.blocks.forEach((e, i) => {
            //通过距离空位距离为1来查找后续的状态
            if (this.calcDistance(this.getPlaceBlock(index0), this.getPlaceBlock(i)) === 1) {
                const nextBlocks = _.cloneDeep(this.blocks)
                    ;[nextBlocks[i], nextBlocks[index0]] = [nextBlocks[index0], nextBlocks[i]]
                const nextBlockState = new BlockState(nextBlocks, this.robot, this)
                nextBlockState.getF()
                nextBlockState.setMoveBlocks(i + 1, index0 + 1)
                childBlocks.push(nextBlockState)
            }
        })
        return childBlocks
    }
    //获取上级移动动作
    getSuccessMove() {
        const moveSteps: any = []
        const getParentMoveStep = (state: BlockState) => {
            if (state.parentBlockState) {
                moveSteps.unshift(state.moveStep)
                getParentMoveStep(state.parentBlockState)
            }
        }
        getParentMoveStep(this)
        return moveSteps
    }
}

export default class Robot {
    openStateList: any[] = []
    closeStateList: any[] = []

    //开始数据组合
    startBlocks: number[] = []
    rows = 3
    cols = 3
    blankBlockIndex = 8

    //成功组合
    successBlocks: number[] = []

    state = Array(362880).fill(false)

    constructor(startBlocks: number[], rows = 3, cols = 3) {
        this.startBlocks = startBlocks
        this.rows = rows
        this.cols = cols
        for (let i = 0; i < rows * cols; i++) {
            this.successBlocks.push(i)
        }
        this.blankBlockIndex = rows * cols - 1
    }

    //运行
    crackRun() {
        //根据逆序对检查是否可还原
        const copyStartBlocks: any = _.cloneDeep(this.startBlocks)
        const copySuccessBlocks: any = _.cloneDeep(this.successBlocks)

        const checkRes = this.checkCrash(copyStartBlocks, copySuccessBlocks)

        if (!checkRes) {
            throw new Error('当前拼图不可被还原')
        }

        let successState

        //初始化块
        const startBlockState: any = new BlockState(this.startBlocks, this)
        this.openStateList.push(startBlockState)
        let isCracked = false
        let countStep = 1
        while (this.openStateList.length > 0) {
            const checkState = this.openStateList.shift()
            this.closeStateList.push(checkState)
            if (checkState.getBlockData() === this.successBlocks.toString()) {
                successState = checkState
                isCracked = true
                break
            }
            //扩展子状态
            let childBlocks = checkState.expand()
            if (childBlocks) {
                //判断状态是否已经校验过
                childBlocks = childBlocks.filter((e: BlockState) => {
                    const cantorRes = this.cantor(e.blocks)
                    return cantorRes
                })
                //根据估值进行排序
                childBlocks.sort((a: BlockState, b: BlockState) => {
                    return a.getF() - b.getF()
                })
                this.openStateList.push(...childBlocks)
            }
            countStep++
        }
        if (isCracked && successState) {
            const steps = successState.getSuccessMove()
            return steps
        }
        throw new Error('臣妾做不到')
    }

    cantor(path: number[]) {
        const fac = [1, 1, 2, 6, 24, 120, 720, 5040, 40320]
        let sum = 0
        for (let i = 0; i < 9; i++) {
            let t = 0
            for (let j = i + 1; j < 9; j++) {
                if (path[j] < path[i]) {
                    t++
                }
            }
            sum += t * fac[8 - i]
        }
        if (this.state[sum] == true) {
            return false
        }

        this.state[sum] = true
        return true
    }

    //判断是否可以解出
    checkCrash(startBlock: number[], successBlocks: number[]) {
        return this.inverseCount(startBlock) === this.inverseCount(successBlocks)
    }
    //计算逆序对 暴力查询
    inverseCount(blocks: number[]) {
        let num = 0
        blocks.splice(blocks.indexOf(this.blankBlockIndex), 1)
        blocks.forEach((item, index) => {
            for (let i = 0; i < index; i++) {
                if (blocks[i] != this.blankBlockIndex && blocks[i] > item) {
                    num++
                }
            }
        })
        return num % 2 ? 1 : 0
    }
}
